const deepClone = (value) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (error) {
    return value;
  }
};

export const createDuplicatedObject = (
  sourceObject,
  allObjects = [],
  options = {}
) => {
  if (!sourceObject) return null;

  const {
    offsetX = 20,
    offsetY = 20,
    nameSuffix = "copy",
  } = options;

  const maxZIndex = allObjects.length
    ? Math.max(...allObjects.map((obj) => obj.z_index ?? 0))
    : (sourceObject.z_index ?? 0);

  const baseName = sourceObject.name || sourceObject.type || "object";
  const duplicatedName = `${baseName}-${nameSuffix}-${Date.now()}`;

  return {
    ...deepClone(sourceObject),
    id: `temp-${Date.now()}-${Math.floor(Math.random() * 10000)}`,
    name: duplicatedName,
    x: Number(sourceObject.x || 0) + offsetX,
    y: Number(sourceObject.y || 0) + offsetY,
    z_index: maxZIndex + 1,
    isNew: true,
    style_json: deepClone(sourceObject.style_json || {}),
    data_json: deepClone(sourceObject.data_json || {}),
    meta_json: deepClone(sourceObject.meta_json || {}),
  };
};